require('./wizard.style.scss');

class WizardController {
  constructor($scope, $localStorage, docsService, utilsService) {
    this.$scope = $scope;
    this.$localStorage = $localStorage;
    this.docsService = docsService;
    this.isBackupAdmin = utilsService.isBackUpAdmin();
    this.dontShowWizard = false;
    
    this.showWatcher = $scope.$watch(() => this.showWizard , showWizard => {
        if(showWizard) {
            this.isOrganizationAccount = utilsService.isOrganizationAccount();
            this.showWatcher();
        }
      }); 

    $scope.$watch(() => this.dontShowWizard, dontShowWizard => {
      this.$localStorage['show-startup-wizard'] = dontShowWizard;
      // this.$localStorage['show-startup-wizard'] = this.$localStorage['show-startup-wizard'] ? this.$localStorage['show-startup-wizard'] : dontShowWizard;
    });
  }

  $onInit() {
    this.dontShowWizard = this.$localStorage['show-startup-wizard'] ? this.$localStorage['show-startup-wizard'] : false;
  }

  onChange(index) {
    if (!this.navigationEvent) {
        this.index = index;
    }
  }

  onWizardVisit() {
    this.docsService.openHelpWindow();
    this.index = 0;
    this.showWizard = false;
  }

  onWizardDone() {
    this.$localStorage['show-startup-wizard'] = true;
    this.dontShowWizard = true;
    this.index = 0;
    this.showWizard = false;
  }

  onWizardNext() {
    this.navigationEvent = false;
    this.carousel.next();
  }

  onWizardBack() {
    this.navigationEvent = false;
    this.carousel.prev();
  }

  onWizardClose() {
    this.index = 0;
    this.showWizard = false;
  }

  goToStep(index) {
    this.index = index;
    this.carousel.goTo(index);
  }

  navigateTo(index) {
    this.navigationEvent = true;
    this.goToStep(index);
  }

  setCarousel(carousel) {
    this.index = 0;
    this.carousel = carousel;
  }
}

WizardController.$inject = ['$scope', '$localStorage', 'docsService', 'utilsService'];

const wizardComponent = {
  controller: WizardController,
  template: require('./wizard.template.html'),
  bindings: {
    showWizard: '='
  }
};

module.exports = wizardComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/mainApp/dialogs/wizard/wizard.component.js